export type TranslationLanguageEntry = {
  languageName: { simpleText: string };
  languageCode: string;
};

/** Mirrors translation.js loadTranslationEngineJson. */
export function loadTranslationEngineJson(
  json: { translation: Record<string, { nativeName: string }> },
  store: TranslationLanguageEntry[],
): void {
  const codes = Object.keys(json.translation);
  for (let i = 0; i < codes.length; i += 1) {
    const code = codes[i];
    if (!code) continue;
    const entry = json.translation[code];
    if (!entry || entry.nativeName === '') continue;
    store.push({
      languageName: { simpleText: entry.nativeName },
      languageCode: code,
    });
  }
}

/** Mirrors translation.js selectionConverterTranslationLanguages (B-TR-06). */
export function selectionConverterTranslationLanguages(
  translationLanguages: TranslationLanguageEntry[],
): Array<{ name: string; value: number; code: string }> {
  return translationLanguages.map((translationLanguage, index) => ({
    name: translationLanguage.languageName.simpleText,
    value: index,
    code: translationLanguage.languageCode,
  }));
}

/** Mirrors translation.js pickPreferredTranslation (B-SEL-01 translation side). */
export function pickPreferredTranslationIndex(
  preferredCodes: string[],
  translationLanguages: TranslationLanguageEntry[],
): number | undefined {
  if (preferredCodes[0] === 'null') return undefined;

  for (let i = 0; i < preferredCodes.length; i += 1) {
    const translationCode = preferredCodes[i];
    if (!translationCode) continue;

    for (let j = 0; j < translationLanguages.length; j += 1) {
      const languageCode = translationLanguages[j]?.languageCode;
      if (languageCode && translationCode.toLowerCase() === languageCode.toLowerCase()) {
        return j;
      }
    }
  }

  return undefined;
}
